import Vue from 'vue'
import Storage from 'vue-ls'
import '@/assets/scss/main.scss'
import '@/assets/scss/atom.scss'
import filters from '@/filters'
import config from '@/config'
import VueLazyload from 'vue-lazyload'
// import vivojsbridge from '@vivo/vivojsbridge/dist/vivo_native.js'
import { Track } from '@vivo/shop-directives'
import expTrack from '@/directives/track'
import API from '@/api'
import directives from '@/directives'
import UI from '@/components'
import '@/icons'
import { app } from '@/utils'
import Collapse from 'components/collapse'
import PortalVue from 'portal-vue'
import { Dialog } from '@vivo/vos-ui'

Vue.prototype.$toast = app.toast
Vue.use(PortalVue)
Vue.prototype.$osDialog = Dialog
// 接入监控
window.VMonitor && window.VMonitor.initVue(Vue)

const options = {
  namespace: 'vuejs__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}

Vue.use(Storage, options)

// 初始化埋点指令
Vue.use(Track, {
  callback(data) {
    API.logAll(data)
  }
})

// 初始化新曝光埋点指令
Vue.use(expTrack, {
  callback(data) {
    API.logAll(data)
  }
})

// 临时方案,用于在跳转链接前加base路径,彻底分离之后可删除此配置
Vue.prototype.linkBase = config.path.shopUrl
Vue.prototype.linkBasePlus = config.path.shopPlusUrl
Vue.prototype.$track = data => API.logAll(data)
Vue.use(UI)
// 图片懒加载
Vue.use(VueLazyload, {
  observer: true, // 是否启用Intersection Observer提升计算性能
  attempt: 1, // 尝试加载次数,
  filter: {
    // 如果浏览器支持webp，则加载webp图片
    webp(listener, options) {
      const reg = /\.webp$/
      const ignoreWebp = listener.el.classList && listener.el.classList.contains('webp__disabled')
      if (options.supportWebp && !ignoreWebp && /\.vivo\.com/.test(listener.src)) {
        if (/vivoshop\-recycle/.test(listener.src) && !/\.gif$/.test(listener.src)) { // 适配轩辕存储
          listener.src += '@base@tag=imgScale&F=WEBP'
        } else if (!reg.test(listener.src)) {
          listener.src += '.webp'
        }
      }
    }
  },
  adapter: {
    // 当webp图片下载失败时，自动下载非webp图片
    error({ el, src }) {
      const reg = /\.webp$/
      const reg2= /@base@tag=imgScale&F=WEBP/
      if (reg.test(src) || reg2.test(src)) {
        el.src = src.replace(reg, '').replace(reg2, '')
        el.onload = function () {
          el.setAttribute('lazy', 'loaded')
        }
      }
    }
  }
})

// window.vivojsbridge = vivojsbridge
// 注册指令
Object.keys(directives).forEach(key => {
  Vue.use(directives[key])
})
// 注册过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 注册折叠展开组件
Vue.component('collapse', Collapse())
Vue.component('collapse-group', Collapse(true))

Vue.config.productionTip = false
